import React, { Component } from 'react';
import { Row, Col, ButtonGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { VersionsIcon, XCircleFillIcon } from '@primer/octicons-react';

import i18n from "../../../../../_translations/i18n"; 

import { removeGhostImage } from '../../../../common_layouts/ghostDragWrapper';

class EditSimulateClipBoard extends Component {
    constructor(props){
        super(props); 
        this.state = {
            selectedItems: []
        }
    }

    handleGhostOnDrag = (e, obj) => {
        let viewobj = JSON.parse(JSON.stringify(obj));

        //calculate the width and height of the group
        let totalDrawWidth  = 0;
        let totalDrawHeight = 0;

        this.props.clipDragType === "SINGLE" && viewobj && viewobj?.map((prod, i) => {
             totalDrawWidth  += prod.drawWidth;
             totalDrawHeight = prod.drawHeight;
        });

        let drawzoomx = this.props.zoomXRatio;
        let prodwidth = (this.props.clipDragType === "SINGLE"?totalDrawWidth:obj.width);
        let prodheight = (this.props.clipDragType === "SINGLE"?totalDrawHeight:obj.height);
        // // // let prodwidth = (this.props.clipDragType === "SINGLE"?obj.drawWidth:obj.width);
        // // // let prodheight = (this.props.clipDragType === "SINGLE"?obj.drawHeight:obj.height);
        viewobj["drawWidth"] = prodwidth * (drawzoomx > 0?(drawzoomx * 2):1);
        viewobj["drawHeight"] = prodheight * (drawzoomx > 0?(drawzoomx * 2):1);

        // SINGLE mode: obj is array of products - check each for price tag
        if (this.props.clipDragType === "SINGLE" && Array.isArray(obj)) {
            let maxPriceTagExtra = 0;
            for (let p = 0; p < obj.length; p++) {
                let cprod = obj[p];
                const hasPT = cprod.hasPriceTagLatest || cprod.product?.hasPriceTagLatest;
                if (hasPT) {
                    const ptH = (cprod.priceTagHeightLatest || cprod.product?.priceTagHeightLatest || 0) * this.props.displayRatio;
                    const ptG = (cprod.priceTagGapLatest ||  cprod.product?.priceTagGapLatest|| 0) * this.props.displayRatio;
                    maxPriceTagExtra = Math.max(maxPriceTagExtra, ptH + ptG);
                }
            }
            if (maxPriceTagExtra > 0) {
                viewobj.drawHeight += maxPriceTagExtra;
            }
        }
        // MULTIPLE mode: obj is cut item with shelf array
        if (this.props.clipDragType === "MULTIPLE" && obj?.shelf) {
            let maxPriceTagExtra = 0;
            for (let s = 0; s < obj.shelf.length; s++) {
                let prods = obj.shelf[s].products || [];
                for (let p = 0; p < prods.length; p++) {
                    let cprod = prods[p];
                    const hasPT = cprod.hasPriceTagLatest || cprod.product?.hasPriceTagLatest;
                    if (hasPT) {
                        const ptH = (cprod.priceTagHeightLatest ||  cprod.product?.priceTagHeightLatest || 0) * this.props.displayRatio;
                        const ptG = (cprod.priceTagGapLatest ||  cprod.product?.priceTagGapLatest ||  0) * this.props.displayRatio;
                        maxPriceTagExtra = Math.max(maxPriceTagExtra, ptH + ptG);
                    }
                }
            }
            if (maxPriceTagExtra > 0) {
                viewobj.drawHeight += maxPriceTagExtra;
            }
        }
        
        this.props.ghostFromParent(e, viewobj, true);
    }

    removeSingleGhost = (iscutparent, e, cutobj, cutidx) => {
        this.props.setPreviewGuid(true);
        removeGhostImage();

        if(iscutparent && e){
            /* let clientxy = this.props.xyChangeCoords(e);
            
            let cutexportobj = cutobj;
            cutexportobj["x"] = clientxy.x;
            cutexportobj["y"] = clientxy.y;

            let cutdragobj = this.props.cutDragObj;
            this.props.dropCutblock(e, cutdragobj.shelfobj, null, cutdragobj.shelfidx, cutexportobj, cutidx, cutdragobj.fieldobj); */
        }
    }

    handleCheckboxChange = (groupUUID) => {
        this.setState(prevState => {
            const { selectedItems } = prevState;
            if (selectedItems.includes(groupUUID)) {
                return { selectedItems: selectedItems.filter(id => id !== groupUUID) };
            } else {
                return { selectedItems: [...selectedItems, groupUUID] };
            }
        });
    };

    handleClear = () => {
        const { selectedItems } = this.state;
        if (selectedItems.length > 0) {
            this.props.clearSelectedCutProducts(selectedItems);
            // this.setState({ selectedItems: [] });
        } else {
            this.props.clearAllCutProducts();
        }
    };

    render() {
        let divHeight = this.props.catDivHeight;
        const clearButtonText = this.state.selectedItems.length > 0 ? i18n.t("CLEAR_SELECTION") : i18n.t("CLEAR_ALL");

        return (
            <div className="clipboard-simulate">
                {/* <h4>{i18n.t("CLIP_BOARD")}</h4> */}

                {/* <Col>
                    {(this.props.cutArray && this.props.cutArray.length>0)?<>
                        
                        <Col style={{height:"5px",marginTop:"10px"}}>
                            <ButtonGroup style={{direction:"ltr"}} className={"pviewchange-list "+(this.props.isRTL=== "rtl"?"float-left":"float-right")}>
                                <Button variant="secondary" onClick={() => this.props.toggleClipDragType("SINGLE")} className={(this.props.clipDragType==="SINGLE"?"active":"")} title="Single item drag"><FeatherIcon icon="square" size={14} /></Button>
                                <Button variant="secondary" onClick={() => this.props.toggleClipDragType("MULTIPLE")} className={(this.props.clipDragType==="MULTIPLE"?"active":"")} title="Multiple items drag"><VersionsIcon size={16} /></Button>
                            </ButtonGroup>
                        </Col>
                        <Col className="scroll-content" style={{marginTop:"15px",width:"100%"}}>
                            {this.props.cutArray.map((obj,i)=>{
                                return <Col className={"block-out"+(obj.iscopy?" copy-item":"")} key={i} draggable={this.props.clipDragType==="MULTIPLE"}
                                onDragStart={e => (this.props.clipDragType==="MULTIPLE"?this.props.dragStart(e,obj,false,i):null)} 
                                onMouseDown={(e) => (this.props.clipDragType==="MULTIPLE"?this.props.drawRectCanvas(obj):null)}
                                onDrag={e => (this.props.clipDragType==="MULTIPLE"?this.handleGhostOnDrag(e,obj):null)} 
                                onDragEnd={() => (this.props.clipDragType==="MULTIPLE"?this.removeSingleGhost():null)}>

                                    <div className='img-wrapper' style={{width: (obj.width + 10), height: (obj.height + 10),direction: "ltr" }}>
                                        <span className='close-link' onClick={() => this.props.updateSingleCutProduct(null, true, i)}><XCircleFillIcon size={12} /></span>

                                        {(obj.prods && obj.prods.length>0)?obj.prods.map((imge,f)=>{
                                            return <React.Fragment key={f}>
                                                <img src={imge.imageUrl} height={imge.drawHeight} width={imge.drawWidth} style={{marginLeft: imge.x, marginTop: imge.gaptolowy}} alt=""
                                                    draggable={this.props.clipDragType==="SINGLE"}
                                                    onDragStart={e => (this.props.clipDragType==="SINGLE"?this.props.dragStart(e, imge, false, i, true, f):null)} 
                                                    onMouseDown={(e) => (this.props.clipDragType==="SINGLE"?this.props.drawRectCanvas(imge):null)}
                                                    onDrag={e => (this.props.clipDragType==="SINGLE"?this.handleGhostOnDrag(e,imge):null)} 
                                                    onDragEnd={() => (this.props.clipDragType==="SINGLE"?this.removeSingleGhost(imge):null)}
                                                    /> 

                                            </React.Fragment>
                                        }):<></>}
                                    </div>
                                </Col>
                            })}
                        </Col>
                        
                    </>:<><Col xs={12} className="text-center" style={{paddingTop:"10px"}}><h5 className='noclip-txt'>{i18n.t("NO_CLIPBOARD_ITEMS")}</h5></Col></>}
                </Col> */}
                <Col>
                {(this.props.cutNewArray && this.props.cutNewArray.length>0)?<>
                        <div className={'clipboard-btn-container'}>
                        <Button className='clear-button' onClick={this.handleClear}>
                            <span
                                style={{ marginRight: 5, marginLeft: 5 }}
                            >
                                {i18n.t(this.state.selectedItems.length > 0 ? "CLEAR_SELECTION" : "CLEAR_ALL")}
                            </span>
                            <FeatherIcon icon={"trash"} size={10} strokeWidth={3} />
                        </Button>
                        <div style={{height:"5px",marginTop:"10px"}}>
                            <ButtonGroup style={{direction:"ltr"}} className={"pviewchange-list "+(this.props.isRTL=== "rtl"?"float-left":"float-right")}>
                                {this.props.isRTL === "rtl" ? (
                                    <>
                                        <Button variant="secondary" onClick={() => this.props.toggleClipDragType("MULTIPLE")} className={(this.props.clipDragType==="MULTIPLE"?"active":"")} title="Multiple group drag"><VersionsIcon size={16} /></Button>
                                        <Button variant="secondary" onClick={() => this.props.toggleClipDragType("SINGLE")} className={(this.props.clipDragType==="SINGLE"?"active":"")} title="Single group drag"><FeatherIcon icon="square" size={14} /></Button>
                                    </>
                                ) : (
                                    <>
                                        <Button variant="secondary" onClick={() => this.props.toggleClipDragType("SINGLE")} className={(this.props.clipDragType==="SINGLE"?"active":"")} title="Single group drag"><FeatherIcon icon="square" size={14} /></Button>
                                        <Button variant="secondary" onClick={() => this.props.toggleClipDragType("MULTIPLE")} className={(this.props.clipDragType==="MULTIPLE"?"active":"")} title="Multiple group drag"><VersionsIcon size={16} /></Button>
                                    </>
                                )}
                            </ButtonGroup>
                        </div>
                        </div>
                        <Col className="scroll-content" style={{marginTop:"15px",width:"100%", height: this.props.simType === 'AUI' ? divHeight - 60 : divHeight + 180}}>
                            {[...this.props.cutNewArray].reverse().map((obj, i) => {
                                const allProducts = obj.shelf.flatMap(s => s.products);
                                let isDel = false;
                                allProducts?.forEach((item) => {
                                    if (item.isProductDelete) {
                                        isDel = true;
                                    }
                                })
                                var filteredshelf=obj.shelf.filter(c=>c.isDelete!==true)
                                return <div className={"clipboard-item-block block-out"+(obj.mode==="copy"?" copy-item":"")} key={i} draggable={this.props.clipDragType==="MULTIPLE"}
                                onDragStart={e => (this.props.clipDragType==="MULTIPLE"?this.props.dragStart(e,obj,false,i):null)} 
                                onMouseDown={(e) => (this.props.clipDragType==="MULTIPLE"?this.props.drawRectCanvas(obj):null)}
                                onDrag={e => (this.props.clipDragType==="MULTIPLE"?this.handleGhostOnDrag(e,obj):null)} 
                                onDragEnd={(e) => (this.props.clipDragType==="MULTIPLE"?this.removeSingleGhost(true, e, obj, i):null)}
                                >
                                    <div className='clipboard-item-left'>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedItems.includes(obj.groupUUID)}
                                            onChange={() => this.handleCheckboxChange(obj.groupUUID)}
                                            style={{
                                                marginRight: 12,
                                            }}
                                        />
                                        <div style={{maxWidth: this.props.simType === 'AUI' ? '24vw' : '19vw', overflow: 'auto'}}>
                                            {(filteredshelf && filteredshelf.length > 0) ? filteredshelf.map((shlf, k) => {
                                            return <div key={k} className='img-wrapper'
                                            style={{
                                               width: (shlf.width + 10), 
                                               height: (shlf.height + 10),
                                               marginRight: '15px',
                                               direction: "ltr"
                                            }}>
                                                
                                                {(shlf.products && shlf.products.length>0) && shlf.products.map((imge,f)=>{

                                                    const uniqueGroupItems = shlf.products.filter(product => product.groupId === imge.groupId);

                                                    return <React.Fragment key={f}>
                                                        <div 
                                                            draggable={this.props.clipDragType==="SINGLE"}
                                                            onDragStart={e => (this.props.clipDragType==="SINGLE"?this.props.dragStart(e, obj, false, i, true, imge.groupId,k,imge.groupId,imge.shelfrank,obj.groupUUID, uniqueGroupItems):null)}
                                                            onMouseDown={(e) => (this.props.clipDragType==="SINGLE"?this.props.drawRectCanvas(obj):null)}
                                                            onDrag={e => (this.props.clipDragType==="SINGLE"?this.handleGhostOnDrag(e,uniqueGroupItems):null)} 
                                                            onDragEnd={() => (this.props.clipDragType==="SINGLE"?this.removeSingleGhost(obj):null)}
                                                        >
                                                        {imge.isDelete !== true && <img src={imge.imageUrl} height={imge.drawHeight} width={imge.drawWidth} style={{marginLeft: imge.x, marginTop: imge.gaptolowy}} alt=""/>}
                                                        </div>
                                                        {/* OLD item wise pick */}
                                                        {/* {imge.isDelete!==true?<img src={imge.imageUrl} height={imge.drawHeight} width={imge.drawWidth} style={{marginLeft: imge.x, marginTop: imge.gaptolowy}} alt=""
                                                            draggable={this.props.clipDragType==="SINGLE"}
                                                            onDragStart={e => (this.props.clipDragType==="SINGLE"?this.props.dragStart(e, imge, false, i, true, f,k,imge.id,shlf.shelfRank,obj.groupUUID):null)} 
                                                            onMouseDown={(e) => (this.props.clipDragType==="SINGLE"?this.props.drawRectCanvas(imge):null)}
                                                            onDrag={e => (this.props.clipDragType==="SINGLE"?this.handleGhostOnDrag(e,imge):null)} 
                                                            onDragEnd={() => (this.props.clipDragType==="SINGLE"?this.removeSingleGhost(imge):null)}
                                                            />:<></> } */}
                                                    </React.Fragment>
                                                })}
                                            </div>
                                            }) : <></>}
                                        </div>
                                    </div>
                                    <div className='clipboard-item-right'>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-remove-item" dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"}>
                                                    {i18n.t("REMOVE_ITEM")}
                                                </Tooltip>
                                            }
                                        >
                                            <span onClick={() => this.props.updateSingleCutProduct(null, true, i, obj.groupUUID, true)}><XCircleFillIcon size={12} fill={this.props.dmode ? "#ED6B69" : "#5128a0"} /></span>
                                        </OverlayTrigger>
                                        {
                                            obj.mode === "delete" ? <span className='option-icon' ><FeatherIcon icon={"trash"} size={10} strokeWidth={3} /></span> :
                                                obj.mode === "cut" ? <span className='option-icon' ><FeatherIcon icon={"scissors"} size={10} strokeWidth={3} /></span> :
                                                    obj.mode === "copy" ? <span className='option-icon' ><FeatherIcon icon={"copy"} size={10} strokeWidth={3} /></span> :
                                                        <></>
                                        }
                                        {
                                            isDel && <span className='option-icon' ><FeatherIcon icon={"alert-triangle"} size={10} strokeWidth={3} /></span>
                                        }
                                    </div>
                                </div>
                            })}
                        </Col>
                        
                    </>:<><Col xs={12} className="text-center" style={{paddingTop:"10px"}}><h5 className='noclip-txt'>{i18n.t("NO_CLIPBOARD_ITEMS")}</h5></Col></>}
                </Col>
            </div>
        );
    }
}

export default EditSimulateClipBoard;